import React, { Component } from 'react';

import logoPlank from '../../assets/img/logo-redesign.svg';
import { Chest, CloseButton, Header, Link, LinkContainer, Paragraph, Pic, Plank, Text, Wrapper } from './styled';

class PlankMobile extends Component {
    render() {

        const {
            headerText,
            text,
            pic,
            href,
            linkName,
            isOpen,
            onCloseLink,
            onClosePlank,
        } = this.props;

        return (
            <Plank isOpen={isOpen}>
                <Wrapper>
                    <Pic src={pic}/>
                    <Text>
                        <Header>{headerText}</Header>
                        <Paragraph>{text}</Paragraph>
                    </Text>
                </Wrapper>
                <LinkContainer>
                    <Link href={href} onClick={onCloseLink}>{linkName}</Link>
                </LinkContainer>
                <CloseButton onClick={onClosePlank} data-test='close-btn'>
                    <Chest />
                </CloseButton>
            </Plank>
        );
    }
}

PlankMobile.defaultProps = {
    headerText: 'Мой Дом.ру',
    text: 'Управляйте услугами в приложении',
    href: 'https://app.dom.ru/open',
    linkName: 'Открыть',
    pic: logoPlank,
    domain: 'perm',
    onCloseLink: () => {},
    onClosePlank: () => {},
};

export default PlankMobile;
